import React, { useRef } from 'react';
import { Flex, FlexProps, Text } from 'rebass';
import useSize from '@react-hook/size';

type DashboardWidgetProps = FlexProps & {
  title?: string;
  subtitle?: string;
  headerAction?: React.ReactNode;
  bodySx?: FlexProps['sx'];
  component: <P extends { width: number; height: number }>(
    props: P
  ) => JSX.Element;
};

const DashboardWidget = (props: DashboardWidgetProps): JSX.Element => {
  const Component = props.component;
  const { title, subtitle, headerAction, bodySx } = props;

  const elementRef = useRef<HTMLElement>(null);
  const [width, height] = useSize(elementRef);

  return (
    <Flex
      {...(props as any)}
      sx={{
        boxShadow: 'feature',
        borderRadius: 'default',
        bg: 'white',
        padding: 4,
        ...props.sx,
      }}
      flexDirection="column"
    >
      <Flex
        flexShrink={0}
        flexGrow={0}
        alignItems="baseline"
        justifyContent="space-between"
      >
        <Flex alignItems="baseline" sx={{ minWidth: 0 }}>
          <Text variant="heading3">{title}</Text>
          <Text ml={1} variant="body2" color="#9D9D9D">
            {subtitle || <>&nbsp;</>}
          </Text>
        </Flex>
        {headerAction}
      </Flex>

      <Flex
        ref={elementRef}
        flexGrow={1}
        sx={{
          marginTop: 3,
          overflow: 'hidden',
          position: 'relative',
          ...bodySx,
        }}
      >
        {Component && <Component width={width} height={height} />}
      </Flex>
    </Flex>
  );
};

export default DashboardWidget;
